import { getMessage } from '@tcc/i18n';

const NONRETRYABLE_KEY = 'past.error.nonretryable';
const RETRYABLE_KEY = 'past.error.retryable';

/**
 * Handles past weather errors
 * @param {Object[]} errors - Errors received from our wheather service.
 * @param {string} errors[].field_id - Id of the field that requested past weather.
 * @param {string} errors[].value - Error value.
 * @param {boolean} errors[].retryable - true means temporary error, permanent otherwise.
 */

export const pastWeatherErrorHandler = (errors) => {
  const showRetryableError = errors.every((error) => error.retryable);
  const key = showRetryableError ? RETRYABLE_KEY : NONRETRYABLE_KEY;
  return getMessage(key);
};
